import { Component, Input, OnInit } from "@angular/core";
import { BrandingService } from "src/app/core/services/branding.service";
import { AssistantContent } from "../../../models";

@Component({
  selector: "app-assistant-banner-content",
  templateUrl: "./assistant-banner-content.component.html",
  styleUrls: ["./assistant-banner-content.component.scss"],
  standalone: false,
})
export class AssistantBannerContentComponent implements OnInit {
  @Input() content: AssistantContent;

  constructor(public brandingService: BrandingService) {}

  ngOnInit(): void {}
}
